export default __webpack_public_path__ + "static/media/globe.0fe6075a.svg";